import React from "react";

const GraphBlock = ({ block }) => {
    const data = block.data || [];

    return (
        <div
            style={{
                margin: "20px 0",
                padding: 20,
                border: "1px dashed #777",
                borderRadius: 8,
            }}
        >
            {block.title && (
                <h3>{block.title}</h3>
            )}

            <div
                style={{
                    textAlign: "center",
                    fontWeight: 700,
                }}
            >
                {block.y_axis}
            </div>

            <div
                style={{
                    marginTop: 20,
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                }}
            >
                {data.map((point, index) => (
                    <div key={index}>
                        ({point.x}, {point.y})
                    </div>
                ))}
            </div>

            <div
                style={{
                    textAlign: "center",
                    fontWeight: 700,
                    marginTop: 16,
                }}
            >
                {block.x_axis}
            </div>
        </div>
    );
};

export default GraphBlock;